import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @file Created on Tue Nov 20 2018
 * @author LZe
 */


import { ValidationResultConverter, jsonConversions, ResultSeverity, Utils } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { action, observable } from 'mobx';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { AlertType } from '../../../components/info/Alert/AlertType';
import translate, { translateResultObject } from '../../../components/i18n/translate';
export var MessageStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(MessageStore, _BaseStore);

  function MessageStore() {
    var _this;

    _classCallCheck(this, MessageStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MessageStore).apply(this, arguments));
    _this.name = StoreName.Message;
    _this.list = new Map();
    _this.visible = true;
    /** Create hash from test message */

    _this.hashString = function (str) {
      var hash = 0;

      for (var i = 0; i < str.length; i++) {
        hash += Math.pow(str.charCodeAt(i) * 31, str.length - i); // tslint:disable-next-line

        hash = hash & hash;
      }

      return hash.toString();
    };
    /** If message exists, we just increment count, else set it to map */


    _this.set = function (text, type, additionalData) {
      // const hash = this.hashString(text);
      // console.log(hash)
      var message = _this.list.get(text);

      if (Utils.isValueMissing(message)) {
        message = {
          date: new Date(),
          type: type,
          text: text,
          count: 1,
          additionalData: additionalData ? [additionalData] : undefined
        };
      } else {
        if (additionalData) {
          message.additionalData.push(additionalData);
        }

        message = Object.assign(Object.assign({}, message), {
          count: message.count + 1
        });
      }
      /** Fixed add always newest message to bottom and scroll to it */


      _this.list.delete(text);

      _this.list.set(text, message);
    };

    _this.remove = function (id) {
      _this.list.delete(id);
    };

    _this.toggleVisible = function () {
      _this.visible = !_this.visible;
    };

    _this.clear = function () {
      _this.list.clear();
    };

    _this.setValidationResult = function (validationResult) {
      validationResult.resultObjects.forEach(function (resultObject) {
        var message = translateResultObject(resultObject);

        switch (resultObject.severity) {
          case ResultSeverity.Error:
            _this.setError(message);

            break;

          case ResultSeverity.Warn:
            _this.setWarning(message);

            break;

          case ResultSeverity.Info:
            _this.setInfo(message);

            break;
        }
      });
    };
    /**
     * Error ValidationResult handler
     * @param {ValidationResultWrapper} validationResult
     * @returns {string[] | null}
     */


    _this.handleErrorValidationResult = function (validationResult) {
      var messages = [];
      validationResult.resultObjects.forEach(function (resultObject) {
        var message = translateResultObject(resultObject);

        switch (resultObject.severity) {
          case ResultSeverity.Error:
            messages.push(message);
            break;

          case ResultSeverity.Warn:
            _this.setWarning(message);

            break;

          case ResultSeverity.Info:
            _this.setInfo(message);

            break;
        }
      });
      return messages.length ? messages : null;
    };

    _this.setError = function (error) {
      var message;
      var additionalData;
      /**
       * Handles string error
       */

      if (Utils.isString(error)) {
        message = translate(error);
      }
      /**
       * Handles error response data object
       */


      if (!Utils.isString(error)) {
        var resData = error.response && error.response.data;

        if (!resData) {
          message = translate(error.message);
        } else {
          /**
           * Set additional error data
           */
          additionalData = Object.assign(Object.assign({}, resData), {
            location: window.location.href
          });
          /**
           * ValidationResult response
           */

          if (resData.validationResult) {
            var vrWrapper = _this.converter.toObject(resData.validationResult, jsonConversions);

            var vrMessages = _this.handleErrorValidationResult(vrWrapper);

            if (!Utils.isValueMissing(vrMessages)) {
              vrMessages.forEach(function (m) {
                _this.set(m, AlertType.Error, additionalData);
              });
              return;
            }

            if (resData.subcode && vrWrapper.resultObjects.some(function (resultObject) {
              return resultObject.messageKey === resData.subcode;
            })) {
              // Don't show error, when there is validation with the same code/messageKey
              return;
            } else if (resData.userMessage && vrWrapper.resultObjects.some(function (resultObject) {
              return resultObject.userMessage === resData.userMessage;
            })) {
              // Don't show error, when there is validation with the same userMessage
              return;
            }
          }
          /**
           * Default error response
           */


          if (resData.userMessage) {
            message = translate(resData.userMessage);
          } else if (resData.subcode) {
            message = translate("ERROR_".concat(resData.code, "_").concat(resData.subcode));
          } else {
            message = translate("ERROR_".concat(resData.code));
          }
        }
      }

      _this.set(message, AlertType.Error, additionalData);
    };

    _this.setWarning = function (message) {
      _this.set(message, AlertType.Warning);
    };

    _this.setSuccess = function (message) {
      _this.set(message, AlertType.Success);
    };

    _this.setInfo = function (message) {
      _this.set(message, AlertType.Info);
    };

    return _this;
  }

  return MessageStore;
}(BaseStore);

__decorate([Inject, __metadata("design:type", ValidationResultConverter)], MessageStore.prototype, "converter", void 0);

__decorate([observable, __metadata("design:type", Map)], MessageStore.prototype, "list", void 0);

__decorate([observable, __metadata("design:type", Boolean)], MessageStore.prototype, "visible", void 0);

__decorate([action, __metadata("design:type", Object)], MessageStore.prototype, "set", void 0);

__decorate([action, __metadata("design:type", Object)], MessageStore.prototype, "remove", void 0);

__decorate([action, __metadata("design:type", Object)], MessageStore.prototype, "toggleVisible", void 0);

__decorate([action, __metadata("design:type", Object)], MessageStore.prototype, "clear", void 0);